(function () {
  'use strict';

  angular
    .module('lead.bulk.status')
    .controller('leadBulkStatusCtrl', leadBulkStatusCtrl);

  leadBulkStatusCtrl.$inject = ['LeadBulkStatus', '$timeout', '$mdToast'];

  function leadBulkStatusCtrl(
    LeadBulkStatus,
    $timeout,
    /** @type {angular.material.IToastService} */ $mdToast,
  ) {
    var vm = this;
    vm.statuses = [];
    vm.getStatuses = getStatuses();

    function getStatuses() {
      LeadBulkStatus.get(function (statuses) {
        var ignoreStatusList = ['Interested', 'Booker', 'Customer', 'Canceled'];

        statuses.forEach(function (item) {
          if (ignoreStatusList.indexOf(item.name) == -1) {
            vm.statuses.push(item);
          }
        });
      });
    }

    $timeout(function () {
      vm.visibleStyle = { opacity: '1' };
    }, 500);

    vm.save = function () {
      LeadBulkStatus.bulkUpdate(
        {
          status_id: vm.statusId,
          query: vm.query,
        },
        function (success) {
          vm.onSave(success);
          $mdToast.show(
            $mdToast
              .simple()
              .textContent('Lead status were changed')
              .position('bottom right')
              .hideDelay(2000),
          );
        },
        function (error) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent('Error: Lead status were not changed')
              .position('bottom right')
              .hideDelay(2000),
          );
        },
      );
    };

    vm.cancel = function () {
      vm.onCancel();
    };
  }
})();
